import MsrSsoCallback from './MsrSsoCallbackContainer'

export default MsrSsoCallback;